import { cloneElement, ReactElement } from 'react';

import { performLogout } from '@cast/infrastructure-api';

type Props = {
  children: ReactElement<{ onClick?: (event: MouseEvent) => void }>;
  screenHint?: string;
};

export const LogoutWrapper = ({ children, screenHint }: Props) => {
  const returnTo = `${window.location.origin}${
    screenHint ? `?screen_hint=${screenHint}` : '/'
  }`;

  return cloneElement(children, {
    onClick: (e: MouseEvent) => {
      children.props.onClick?.(e);
      performLogout(returnTo);
    },
  });
};
